import React from "react";
import "./styled.css";

export default function Podium(props) {
  const { ranking, clasdPodium, order, imgPodium } = props;

  return (
    <>
      <div className="div-singlePodio">
        <img src={imgPodium} className="img-topPodium" />

        <a className="title-podio">{ranking && ranking.name}</a>
        <div className={`podio ${clasdPodium}`}>
          <a>{order}</a>
          <a>{ranking && `${ranking.totalPoints} Pontos`}</a>
        </div>
      </div>
    </>
  );
}
